

import {
    isStringEqualCI
} from "@/utils";
import {
    BorderColorOutlined,
    Cancel,
    DeleteOutline,
    Save
} from "@mui/icons-material";
import {
    GridActionsCellItem,
    GridColDef,
    GridRowModes
} from "@mui/x-data-grid";
import React from "react";
import { CrudGridAdditionalAction, CrudGridProps } from "./interface";


export const getColumnActions = (props: any) => {
    const {  rowModesModel, rows, handleSaveClick,
        handleCancelClick,
        handleEditClick,
        checkboxSelection,
        handleDeleteClick,
        additionalAction,
        shouldShowDelete
    } = props

    const columnActions: GridColDef = {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        width: 100,
        cellClassName: "actions",
        getActions: ({ id }) => {
            const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

            function createAdditionalAction(
                additionalAction: CrudGridAdditionalAction
            ) {
                return additionalAction ? (
                    <GridActionsCellItem
                        label={additionalAction.additionalActionLabel}
                        icon={
                            additionalAction.additionalActionIcon?.() as React.JSX.Element
                        }
                        onClick={() => {
                            additionalAction.additionalActionHandler(id, rows);
                        }}
                        color="inherit"
                    />
                ) : null;
            }

            if (isInEditMode) {
                return [
                    <GridActionsCellItem
                        icon={<Save />}
                        label="Save"
                        sx={{
                            color: "primary.main",
                        }}
                        onClick={handleSaveClick(id)}
                    />,
                    <GridActionsCellItem
                        icon={<Cancel />}
                        label="Cancel"
                        className="textPrimary"
                        onClick={handleCancelClick(id)}
                        color="inherit"
                    />,
                ];
            }

            const defaultAction = [
                <GridActionsCellItem
                    icon={<BorderColorOutlined />}
                    label="Edit"
                    className="textPrimary"
                    onClick={handleEditClick(id)}
                    color="inherit"
                />,
            ];

            if (!checkboxSelection && shouldShowDelete) {
                defaultAction.push(
                    <GridActionsCellItem
                        icon={<DeleteOutline />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />
                );
            }

            if (additionalAction) {
                const action = createAdditionalAction(additionalAction);

                if (action) {
                    defaultAction[
                        isStringEqualCI(additionalAction.position, "start")
                            ? "unshift"
                            : "push"
                    ](action);
                }
            }

            return defaultAction;
        },
    };

    return columnActions
}
